/* DateRestriction.ts */

/* Interfaces */
import { DateRestrictionType } from "src/shared/interfaces/custom-cohorts/DateRestriction";

export const DATE_RESTRICTION: DateRestrictionType[] = [
  DateRestrictionType.FIRST,
  DateRestrictionType.LAST,
];
